const AppActionTypes = {
    getSettings: "getSettings",
    getValidationRules: "getValidationRules",
    getPromotion: "getPromotion",
    getOrder: "getOrder",
    addTracking: "addTracking",
    putAddress: "putAddress"
};

export default AppActionTypes;
